import {
  Row,
  IconWrapper,
  HorizontalSeparator,
  LogoWrapper,
  TooltipContentWrapper,
  Text,
  TooltipValueCus,
  ShortTooltipKeyCus
} from "../../styled/Tooltip.styled";
import { Box } from "@mui/material";
import React, { useEffect, useState, Fragment } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function SingleBestOpTooltip({ data, attr, attrTypes }) {
  const [selectedOperatorDetails, setSelectedOperatorDetails] = useState();
  const [isExpanded, setIsExpanded] = useState(false);
  const attribute = attrTypes?.find(obj => obj?.value === attr);
  const visibleKeys = [attribute?.label, "Service Level", "Aggregation Type",];

  const alwaysVisible = Object.entries(data.body)
    .filter(([key]) => visibleKeys.includes(key))
    .sort(([keyA], [keyB]) => visibleKeys.indexOf(keyA) - visibleKeys.indexOf(keyB));

  const expandable = Object.entries(data.body).filter(
    ([key]) => !visibleKeys.includes(key)
  );

  useEffect(() => {
    setSelectedOperatorDetails(data)
  }, [data]);

  const keysWithSeparators = new Set(["Area", "Signal Strength (dB)", "Download", "Upload"]);
  const keyToImage = {
    "Area": "Area.png",
    "Building Type": "Building Type.png",
    "Latitude": "lat.png",
    "Longitude": "lon.png",
    "OSM Id": "OSM Id.png",
    "Score": "marketShareIcon.png",
    "Total Devices": "devicescore.png",
    "Total Samples": "Total Samples.png",
    "Signal Quality": "No Signal.png",
    "S/N Ratio": "sinrIcon.png",
    "Data Received": "networkActionIcon.png",
    "Data Transceived": "networkActionIcon.png",
    "Download": "download.png",
    "Upload": "upload.png",
    "Data Transmitted": "networkActionIcon.png",
    "Signal Strength": "signal.png",
    "Aggregation Type": "Aggregation Type.png",
    "Service Level": "Service Level.png",
  };

  return (
    <Fragment>
      <Box
        style={{
          minWidth: "245px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {data && (
          <Fragment>
            <Row style={{ height: "20px" }}>
            </Row>
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "30px",
                width: "100%"
              }}
            >
              <IconWrapper style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img src="/assets/bestoperator.png" alt="logo1" width="13" />
                <Text isBold={true} style={{ font: "normal normal bold 12px / 17px Open Sans" }}>
                  Best Operator
                </Text>
              </IconWrapper>

              <LogoWrapper
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "58px",
                  height: "30px"
                }}
              >
                {selectedOperatorDetails?.opIcon && !selectedOperatorDetails?.isAnonymized
                  ? <img
                    src={selectedOperatorDetails.opIcon}
                    alt="operator-logo"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                  : <h4 style={{
                    color: "#707070",
                    fontSize: "10px",
                    textAlign: "center",
                    lineHeight: "18px",
                    border: "1px solid #016F35",
                    borderRadius: "4px",
                    padding: "4px 5px",
                    display: "inline-block",
                    margin: "0" // Ensure there's no extra margin
                  }}>
                    {selectedOperatorDetails?.operatorName}
                  </h4>
                }
              </LogoWrapper>
            </Row>

            <HorizontalSeparator />
            {data.body && (

              <Fragment>
                {alwaysVisible.map(([key, value], idx) => (
                  <Row key={idx} style={{ height: "28px" }}>
                    <TooltipContentWrapper>
                      <ShortTooltipKeyCus
                        style={{ font: key === attribute?.label ? "normal normal bold 12px / 17px Open Sans" : "normal normal normal 12px / 17px Open Sans" }}
                      >
                        {keyToImage[key] ? (
                          <img src={`/assets/${keyToImage[key]}`} alt={key} style={{ marginRight: "8px", width: "13px", height: "13px" }} />
                        ) : (
                          <img src="/assets/ellipse.png" alt="default" style={{ marginRight: "8px", width: "12px" }} />
                        )}
                        {key}
                      </ShortTooltipKeyCus>
                      <TooltipValueCus style={{ font: key === attribute?.label ? "normal normal bold 12px Open Sans" : "normal normal normal 12px / 17px Open Sans" }}>
                        {keysWithSeparators.has(key) && typeof value === 'number'
                          ? value.toLocaleString()
                          : value || ""}
                      </TooltipValueCus>
                    </TooltipContentWrapper>
                  </Row>
                ))}

                {expandable.length > 0 && (
                  <>
                    <HorizontalSeparator />
                    <Box>
                      <button
                        onClick={() => setIsExpanded((prev) => !prev)}
                        style={{
                          margin: "10px 0",
                          marginTop: '3px',
                          background: "none",
                          border: "none",
                          color: "#707070",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          font: "normal normal 600 12px / 17px Open Sans"
                        }}
                      >
                        {isExpanded ? (
                          <>
                            View More Details <KeyboardArrowUpIcon />
                          </>
                        ) : (
                          <>
                            View More Details <KeyboardArrowDownIcon />
                          </>
                        )}
                      </button>
                      {isExpanded &&
                        expandable.map(([key, value], idx) => (
                          <Row
                            key={`expandable-${idx}`}
                            style={{
                              height: "28px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <TooltipContentWrapper>
                              <ShortTooltipKeyCus
                                style={{ font: "normal normal normal 12px / 17px Open Sans" }}>
                                {keyToImage[key] ? (
                                  <img src={`/assets/${keyToImage[key]}`} alt={key} style={{ marginRight: "8px", width: key === "Total Devices" ? "9px" : "13px", height: "13px" }} />
                                ) : (
                                  <img src="/assets/ellipse.png" alt="default" style={{ marginRight: "8px", width: "12px" }} />
                                )}
                                {key}
                              </ShortTooltipKeyCus>
                              <TooltipValueCus>
                                {keysWithSeparators.has(key) && typeof value === 'number'
                                  ? value.toLocaleString()
                                  : value || ""}
                              </TooltipValueCus>
                            </TooltipContentWrapper>
                          </Row>

                        ))}
                    </Box>
                  </>
                )}
              </Fragment>

            )}

            {selectedOperatorDetails?.buildingName ? <HorizontalSeparator /> : <></>}
            <Row style={{ height: "30px" }}>
              {selectedOperatorDetails ? <Box
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: 'center'
                }}
              >
                <Text isBold={true} style={{ font: "normal normal 600 12px / 17px Open Sans", color: "#707070" }}>
                  {selectedOperatorDetails?.buildingName}
                </Text>
              </Box> : <></>}
            </Row>

          </Fragment>
        )}
      </Box>
    </Fragment>
  );
}